import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'src/hooks';
import { feedPageRoute } from './route-list';

export const GuestGuard: FC = ({ children }) => {
  const { isAuthenticated, requestedLocation } = useAuth();

  if (isAuthenticated) {
    if (requestedLocation) {
      return <Navigate to={requestedLocation} />;
    }
    return <Navigate to={feedPageRoute} />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
